export default {
  DOCUMENT: "document",
  EMAIL: "email",
  LETTER: "letter",
  NOTE: "note",
};
